import { useWorkspace, type ExternalAppLink } from "#app/lib/data/app-provider";

/**
 * External companion-app links for the active workspace — the setting-driven
 * source for the sidebar "Apps" section. Returns an empty array when the
 * workspace has none configured (or none has loaded yet).
 */
export function useExternalAppLinks(): ExternalAppLink[] {
  const { activeWorkspace } = useWorkspace();
  return activeWorkspace?.externalAppLinks ?? [];
}
